import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from "react";
import { EmptyTranscriptSegmentSkeleton } from "~/components/AssetModal/shared/components/TranscriptPanel/components/TranscriptSegmentList/components/TranscriptSegment/components/EmptyTranscriptSegment/EmptyTranscriptSegmentSkeleton";
import { MAX_TRANSCRIPT_RANGE_IN_MS } from "~/swr-hooks/clips/transcript/constants";
export const LOADING_TRANSCRIPT_SEGMENT_HEIGHT = 530;
export const MIN_VISIBLE_MS = 100;
export const LoadingTranscriptSegments = /*#__PURE__*/ memo((param)=>{
    let { segment, index, scrollElement, fetchTranscriptForRange } = param;
    const elementRef = useRef(null);
    const mountTime = useRef(0);
    const loadingTimeoutHandle = useRef(0);
    useEffect(()=>{
        // load more items if an element is 100px away from the viewport for at leas MIN_VISIBLE_MS
        const isNearScreenCallback = (entries)=>{
            const currentEntry = entries[0];
            if (!currentEntry) return;
            const { isIntersecting, rootBounds, boundingClientRect } = currentEntry;
            if (!rootBounds || !boundingClientRect) return;
            if (isIntersecting) {
                const isIntersectingFromBottom = boundingClientRect.bottom > (rootBounds === null || rootBounds === void 0 ? void 0 : rootBounds.bottom);
                const isIntersectionFromTop = boundingClientRect.top < (rootBounds === null || rootBounds === void 0 ? void 0 : rootBounds.top);
                clearTimeout(loadingTimeoutHandle.current);
                const { startTimeMs, endTimeMs } = segment;
                mountTime.current = Date.now();
                let startTimeToFetch = startTimeMs;
                let endTimeToFetch = endTimeMs;
                if (isIntersectingFromBottom) {
                    // if user scrolls down, fetch next range
                    endTimeToFetch = startTimeMs + MAX_TRANSCRIPT_RANGE_IN_MS;
                } else if (isIntersectionFromTop) {
                    // if user scrolls up, fetch previous range
                    startTimeToFetch = Math.max(0, endTimeMs - MAX_TRANSCRIPT_RANGE_IN_MS);
                }
                loadingTimeoutHandle.current = window.setTimeout(()=>{
                    fetchTranscriptForRange({
                        startTimeMs: startTimeToFetch,
                        endTimeMs: endTimeToFetch
                    });
                }, MIN_VISIBLE_MS);
            } else {
                clearTimeout(loadingTimeoutHandle.current);
            }
        };
        const isNearScreenObserver = new IntersectionObserver(isNearScreenCallback, {
            root: scrollElement,
            threshold: 0.01,
            rootMargin: "100px"
        });
        if (elementRef.current) {
            isNearScreenObserver.observe(elementRef.current);
        }
        return ()=>{
            isNearScreenObserver.disconnect();
        };
    }, [
        elementRef,
        fetchTranscriptForRange,
        index,
        scrollElement,
        segment
    ]);
    useEffect(()=>{
        return ()=>{
            clearTimeout(loadingTimeoutHandle.current);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        ref: elementRef,
        children: [
            /*#__PURE__*/ _jsx(EmptyTranscriptSegmentSkeleton, {}),
            /*#__PURE__*/ _jsx(EmptyTranscriptSegmentSkeleton, {}),
            /*#__PURE__*/ _jsx(EmptyTranscriptSegmentSkeleton, {}),
            /*#__PURE__*/ _jsx(EmptyTranscriptSegmentSkeleton, {}),
            /*#__PURE__*/ _jsx(EmptyTranscriptSegmentSkeleton, {})
        ]
    });
});
LoadingTranscriptSegments.displayName = "LoadingTranscriptSegments";
